import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "container list"
};
const _hoisted_2 = {
  class: "handle-box"
};
const _hoisted_3 = {
  href: "https://api.zhipaiai.pro",
  target: "_blank",
  style: {
    "margin-left": "10px"
  }
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  class: "dialog-footer"
};
import { onMounted, onUnmounted, reactive, ref } from "vue";
import { httpGet, httpPost } from "@/utils/http";
import { ElMessage } from "element-plus";
import { dateFormat, removeArrayItem, substr } from "@/utils/libs";
import { DocumentCopy, Plus, ShoppingCart, Search } from "@element-plus/icons-vue";
import ClipboardJS from "clipboard";

// 变量定义

export default {
  __name: 'ApiKey',
  setup(__props) {
    const items = ref([]);
    const query = ref({
      type: ""
    });
    const item = ref({});
    const showDialog = ref(false);
    const rules = reactive({
      name: [{
        required: true,
        message: "请输入名称",
        trigger: "change"
      }],
      type: [{
        required: true,
        message: "请选择用途",
        trigger: "change"
      }],
      value: [{
        required: true,
        message: "请输入 API KEY 值",
        trigger: "change"
      }]
    });
    const loading = ref(true);
    const formRef = ref(null);
    const title = ref("");
    const types = ref([{
      label: "对话",
      value: "chat"
    }, {
      label: "Midjourney",
      value: "mj"
    }, {
      label: "Stable-Diffusion",
      value: "sd"
    }, {
      label: "DALL-E",
      value: "dalle"
    }, {
      label: "Suno文生歌",
      value: "suno"
    }, {
      label: "Luma视频",
      value: "luma"
    }, {
      label: "Realtime API",
      value: "realtime"
    }]);
    const isEdit = ref(false);
    const clipboard = ref(null);
    const presets = ref([]);
    const preset = ref(null);
    onMounted(() => {
      clipboard.value = new ClipboardJS(".copy-key");
      clipboard.value.on("success", () => {
        ElMessage.success("复制成功！");
      });
      clipboard.value.on("error", () => {
        ElMessage.error("复制失败！");
      });
      fetchData();
    });
    onUnmounted(() => {
      clipboard.value.destroy();
    });
    const getTypeName = type => {
      for (let v of types.value) {
        if (v.value === type) {
          return v.label;
        }
      }
      return "";
    };

    // 获取数据
    const fetchData = () => {
      httpGet("/admin/apikey/list", query.value).then(res => {
        if (res.data) {
          // 初始化数据
          const arr = res.data;
          for (let i = 0; i < arr.length; i++) {
            arr[i].last_used_at = dateFormat(arr[i].last_used_at);
          }
          items.value = arr;
        }
        loading.value = false;
      }).catch(() => {
        ElMessage.error("获取数据失败");
      });
    };
    const add = function () {
      showDialog.value = true;
      title.value = "新增 API KEY";
      isEdit.value = false;
      item.value = {
        enabled: true,
        api_url: ""
      };
    };
    const edit = function (row) {
      showDialog.value = true;
      title.value = "修改 API KEY";
      item.value = row;
      isEdit.value = true;
    };
    const save = function () {
      formRef.value.validate(valid => {
        if (valid) {
          showDialog.value = false;
          httpPost("/admin/apikey/save", item.value).then(res => {
            ElMessage.success("操作成功！");
            if (!item.value["id"]) {
              const newItem = res.data;
              newItem.last_used_at = dateFormat(newItem.last_used_at);
              items.value.push(newItem);
            }
          }).catch(e => {
            ElMessage.error("操作失败，" + e.message);
          });
        } else {
          return false;
        }
      });
    };
    const remove = function (row) {
      httpGet("/admin/apikey/remove?id=" + row.id).then(() => {
        ElMessage.success("删除成功！");
        items.value = removeArrayItem(items.value, row, (v1, v2) => {
          return v1.id === v2.id;
        });
      }).catch(e => {
        ElMessage.error("删除失败：" + e.message);
      });
    };
    const set = (filed, row) => {
      httpPost("/admin/apikey/set", {
        id: row.id,
        filed: filed,
        value: row[filed]
      }).then(() => {
        ElMessage.success("操作成功！");
      }).catch(e => {
        ElMessage.error("操作失败：" + e.message);
      });
    };
    const changePreset = row => {
      item.value.api_url = row.value;
      if (!item.value.name) {
        item.value.name = row.label;
      }
    };
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_popconfirm = _resolveComponent("el-popconfirm");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_select, {
        modelValue: query.value.type,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => query.value.type = $event),
        placeholder: "类型",
        class: "handle-input"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(types.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_button, {
        icon: _unref(Search),
        onClick: fetchData
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("搜索")])),
        _: 1
      }, 8, ["icon"]), _createVNode(_component_el_button, {
        type: "primary",
        icon: _unref(Plus),
        onClick: add
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("新增")])),
        _: 1
      }, 8, ["icon"]), _createElementVNode("a", _hoisted_3, [_createVNode(_component_el_button, {
        type: "success",
        icon: _unref(ShoppingCart),
        onClick: add,
        plain: ""
      }, {
        default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("购买API-KEY")])),
        _: 1
      }, 8, ["icon"])])]), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: items.value,
          "row-key": row => row.id,
          "table-layout": "auto"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "name",
            label: "名称"
          }), _createVNode(_component_el_table_column, {
            prop: "value",
            label: "API KEY"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(substr)(scope.row.value, 20)), 1), _createVNode(_component_el_icon, {
              class: "copy-key",
              "data-clipboard-text": scope.row.value
            }, {
              default: _withCtx(() => [_createVNode(_unref(DocumentCopy))]),
              _: 2
            }, 1032, ["data-clipboard-text"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "api_url",
            label: "API URL"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(substr)(scope.row.api_url, 30)), 1), _createVNode(_component_el_icon, {
              class: "copy-key",
              "data-clipboard-text": scope.row.api_url
            }, {
              default: _withCtx(() => [_createVNode(_unref(DocumentCopy))]),
              _: 2
            }, 1032, ["data-clipboard-text"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "type",
            label: "类型"
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(getTypeName(scope.row.type)), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "proxy_url",
            label: "代理地址"
          }), _createVNode(_component_el_table_column, {
            label: "最后使用时间"
          }, {
            default: _withCtx(scope => [scope.row['last_used_at'] ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(scope.row["last_used_at"]), 1)) : (_openBlock(), _createBlock(_component_el_tag, {
              key: 1
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("未使用")])),
              _: 1
            }))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "enabled",
            label: "启用状态"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_switch, {
              modelValue: scope.row['enabled'],
              "onUpdate:modelValue": $event => scope.row['enabled'] = $event,
              onChange: $event => set('enabled', scope.row)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "180"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              onClick: $event => edit(scope.row)
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("编辑")])),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_popconfirm, {
              title: "确定要删除当前记录吗?",
              onConfirm: $event => remove(scope.row),
              width: 200
            }, {
              reference: _withCtx(() => [_createVNode(_component_el_button, {
                size: "small",
                type: "danger"
              }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("删除")])),
                _: 1
              })]),
              _: 2
            }, 1032, ["onConfirm"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data", "row-key"])]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => showDialog.value = $event),
        "close-on-click-modal": false,
        title: title.value
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_5, [_createVNode(_component_el_button, {
          onClick: _cache[7] || (_cache[7] = $event => showDialog.value = false)
        }, {
          default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("提交")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: item.value,
          "label-width": "120px",
          ref_key: "formRef",
          ref: formRef,
          rules: rules
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "名称：",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, {
              gutter: 10,
              class: "w-full"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: item.value.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => item.value.name = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: preset.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => preset.value = $event),
                  placeholder: "请选择预设",
                  onChange: changePreset
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(presets.value, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      value: item,
                      label: item.label,
                      key: item.value
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                      _: 2
                    }, 1032, ["value", "label"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "类型：",
            prop: "type"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: item.value.type,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => item.value.type = $event),
              placeholder: "请选择类型"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(types.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  value: item.value,
                  label: item.label,
                  key: item.value
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                  _: 2
                }, 1032, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "API KEY：",
            prop: "value"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => item.value.value = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "API URL：",
            prop: "api_url"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.api_url,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => item.value.api_url = $event),
              autocomplete: "off",
              placeholder: "只填 BASE URL 即可，如：https://api.openai.com 或者 wss://api.openai.com"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "启用状态：",
            prop: "enable"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: item.value.enabled,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => item.value.enabled = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"])])), [[_directive_loading, loading.value]]);
    };
  }
};